<h2>Envios com Transportadora Prioritária (Assinatura)</h2>
<p-toast />
<div>
  <ng-container *ngIf="shipments && cols">
    <app-table
      [elements]="shipments"
      [addButton]="true"
      [addButtonAction]="true"
      addLabel="Novo"
      (addButtonClick)="openCreateDialog()"
      [cols]="cols"
      emptyMessage="Nenhum envio com transportadora prioritária encontrado."
      [exportExcel]="true"
      [exportPdf]="true"
      [lazy]="false"
      sortField="dateCreated"
      [sortOrder]="-1"
      [changeColumns]="true"
      [showTitle]="false"
      modelName="envios-transportadora-prioritaria"
    ></app-table>
  </ng-container>
</div>
